import React, { FC } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SendIcon from '@material-ui/icons/Send';
import { CustomSVG } from 'components';
import { useTranslation } from 'react-i18next';

import { AdminPeopleInvite } from 'Links';

const useStyles = makeStyles(theme => ({
  button: {
    marginLeft: theme.spacing(2),
    backgroundColor: theme.palette.common.white,
    color: theme.palette.grey[600],
    '&:hover': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.grey[700],
    },
  },
}));

interface Props {
  onRequestReport: () => void;
}

const Header: FC<Props> = ({ onRequestReport }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container alignItems="center">
      <Grid item xs>
        <Typography variant="h5" color="textSecondary">
          {t('admin:pendingAcceptedInvites')}
        </Typography>
      </Grid>

      <Grid item>
        <Button
          className={classes.button}
          size="large"
          variant="contained"
          startIcon={<CustomSVG name="download" />}
          onClick={onRequestReport}
        >
          {t('admin:downloadReport')}
        </Button>
      </Grid>

      <Grid item>
        <Button
          className={classes.button}
          size="large"
          variant="contained"
          startIcon={<SendIcon />}
          component={AdminPeopleInvite}
        >
          {t('admin:newInvite')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default Header;
